import { Injectable } from '@angular/core';
import { ApiHttpClientService } from '../../api-http-client.service';
import { environment } from 'src/environments/environment';
import { Tema } from 'src/app/models/api/comercial/pricefy-tema';

@Injectable({
  providedIn: 'root'
})
export class ApiPricefyTemasService {
  private baseUrl = 'DadosPricefy';
  private controller: ApiHttpClientService;

  constructor(
    private api: ApiHttpClientService
  ) {
    this.controller = this.api
      .useBaseUrl(environment.microservice.comercial)
      .useBaseUrl(this.baseUrl);
  }

  getAll() {
    return this.controller.unwrap().get<Tema[]>('ObterTemas');
  }
}
